export default {
  state: {
    profileActionData: undefined,
    profileActionFailed: false,
    profileActionResponsesData: undefined,
    profileActionResponsesFailed: false
  },
  getters: {
    profileActionsLoading(state) {
      return !state.profileActionData && !state.profileActionFailed
    },
    profileActionResponsesDataLoading(state) {
      return !state.profileActionResponsesData && !state.profileActionResponsesFailed
    },
  },
  mutations: {
    setProfileActionData(state, { actions }) {
      state.profileActionData = Object.freeze(actions);
    },
    clearProfileActionData(state) {
      state.profileActionData = undefined;
    },
    setProfileActionFailed(state, failed) {
      state.profileActionFailed = failed;
    },
    setProfileActionResponsesData(state, { responses }) {
      state.profileActionResponsesData = Object.freeze(responses);
    },
    clearProfileActionResponsesData(state) {
      state.profileActionResponsesData = undefined;
    },
    setProfileActionResponsesFailed(state, failed) {
      state.profileActionResponsesFailed = failed;
    },
  },
  actions: {
    async getProfileActionData(context, { profile }) {
      context.commit('clearProfileActionData');
      context.commit('setProfileActionFailed', false);

      await context.rootState.inst.get(
        `/api/notifications/?profile_name=${profile.id}`,
        { backgroundRequest: true }
      ).then((response) => {
        context.commit('setProfileActionData', { actions: response.data });
      }).catch(() => {
        context.commit('setProfileActionFailed', true);
      });
    },
    async postProfileActionData(context, { action, brand }) {
      if (!brand) {
        this._vm.$toast.error("Brand must be set");
        return
      }

      try {
        let resp = await context.rootState.inst.post(
          `/api/notifications/`,
          action,
        );

        let actionId = resp.data._id

        await context.rootState.inst.post(
          `/api/notifications/${actionId}/pinpoint/?brand=${brand.package_id || brand.application}`
        );

        this._vm.$toast.success("Notification sent!");
        context.dispatch('getProfileActionResponses', { clearData: false });
      } catch (e) {
        this._vm.$toast.error("Oops, something went wrong!")
      }
    },
    async deleteProfileActionNotification(context, { action_v2_id, sent_action_id }) {
      try {
        await context.rootState.inst.delete(
          `/api/notifications/${action_v2_id}/pinpoint/${sent_action_id}`
        );

        this._vm.$toast.success("Notification deleted!");
        context.dispatch('getProfileActionResponses', { clearData: false });
      } catch (e) {
        this._vm.$toast.error("Notification failed to delete!")
      }
    },
    async getProfileActionResponses(context, { clearData }) {
      if (clearData) context.commit('clearProfileActionResponsesData');
      context.commit('setProfileActionResponsesFailed', false);

      await context.rootState.inst.get(
        `/api/notifications/responses/`,
        { backgroundRequest: true }
      ).then((response) => {
        context.commit('setProfileActionResponsesData', { responses: response.data });
      }).catch(() => {
        context.commit('setProfileActionResponsesFailed', true);
      });
    },
  }
}